export enum ReportType {
  PricingCondition = 0,
  Entity = 1,
  PriceUpdates = 2,
  Weekly = 3,
  PriceSuggestions = 4,
  PriceMAP = 5,
  GoogleMerchant = 6,
}
